import apiService from '@/services/apiService';

const actions = {
  getFaqs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('faq/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getFaqFilters({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`faq?category=${payload}`)
        .then((response) => {
          commit('getFaqFilters', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postFaq({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('faq', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getFaq({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`faq/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getFaq', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  putFaq({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`faq/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderFaq({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`faq/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderFaqCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`faq_category/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delFaq({ commit }, payload) {
    apiService.delete(`faq/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getFaqCategorys({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('faq_category/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getFaqCategoryDatas({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('faq_category')
        .then((response) => {
          commit('getFaqCategorys', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getFaqCategory({ commit }, payload) {
    apiService.get(`faq_category/${payload}`)
      .then((response) => {
        commit('getFaqCategory', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  putFaqCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`faq_category/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postFaqCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('faq_category', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delFaqCategory({ commit }, payload) {
    apiService.delete(`faq_category/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default actions;
